"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
// common search filter button
const StyledButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;
const FilterButton = props => {
    const { onClick } = props;
    return (react_1.default.createElement(StyledButtonContainer, null,
        react_1.default.createElement(core_1.ButtonGroup, { size: 'small', color: 'primary', variant: 'contained' },
            react_1.default.createElement(core_1.Button, { onClick: onClick },
                react_1.default.createElement(icons_1.FilterList, null)))));
};
exports.FilterButton = FilterButton;
exports.default = exports.FilterButton;
//# sourceMappingURL=FilterButton.js.map